import Axios from "axios";
//import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

export default class Order {
      silence(){
      }
    get_product_id_from_unique_code_( CODICE_UNIVOCO, store ) {
      const url = window.location.hostname;
      let that = this;
      let ui = 'https://'+url+'/wp-script/woo/woocommerceapi/get_varation_by_unique.php?CU='+CODICE_UNIVOCO;
      Axios.get(ui)
      .then(function (response) {
        that.add_item_to_order(response.data.variation_id, store.state.product.id, store.state.product.quantity, store);
      })
    }
    get_product_id_from_unique_code( CODICE_UNIVOCO, 
      PRODID, PREZZO, store ) {
      let hostname = window.location.hostname;
      let params = new URLSearchParams();
      params.append('action', 'add_product_if_not_exist');
      params.append('CU', CODICE_UNIVOCO);
      params.append('PRODID', PRODID);
      params.append('PREZZO', PREZZO);
      params.append('QUANTITY',  store.state.product_store.QUANTITA_RICHIESTA) ;
      params.append('TIPOLOGIA',  store.state.products.SORGENTE[0].tipologia) ;
      let url = this.select_url(hostname);
      Axios.post(url, params)
      .then(function (response) {
        this.response = response;
        store.commit("get_cart_count");
      }).catch(function (error) {
        console.info(error); 
      })
      .finally( () => {
        store.commit('set_flashing', false);
        store.commit('set_ordinando', false);
        store.commit("is_loading_order", { is_loading: false });
      });
    }
    get_product_ricambi_id_from_unique_code( CU, CR, PRODID, PREZZO, 
      QUANTITY, TIPOLOGIA, store , flashing ) {
      let hostname = window.location.hostname;
      let params = new URLSearchParams();
      params.append('action', 'add_product_ricambi_if_not_exist');
      params.append('CU', CU);
      params.append('CR', CR);
      params.append('PRODID', PRODID);
      params.append('PREZZO', PREZZO);
      params.append('QUANTITY', QUANTITY) ;
      params.append('TIPOLOGIA', TIPOLOGIA) ;
      let url = this.select_url(hostname);
      Axios.post(url, params)
      .then(function (response) {
        this.response = response;
        store.commit("get_cart_count");
      }).catch(function (error) {
        console.info(error); 
      })
      .finally( () => {
        store.commit('is_loading_order',{is_loading:false})
        flashing = false;
        this.flasshing =flashing;
      });
    }
    add_item_to_order(variation_id, unique, quantity, store, PRODID) {
      const hostname = window.location.hostname;
      let url = this.select_url(hostname);
      const site = url;
      let params = new URLSearchParams();
      params.append('action', 'woocommerce_ajax_add_to_cart');
      params.append("variation_id", variation_id);
      params.append("product_id", PRODID);
      params.append("quantity", quantity);
      params.append("sku", unique );
      Axios.post(site, params
        ).then(function (response) {
            this.response = response;
        }).catch(function (error) {
            this.error = error;
        }).finally( () => {
          store.commit('set_flashing', false);
        });
      }
      select_url (hostname) {
       let url ="https://"+hostname+"/wp-admin/admin-ajax.php";
       if (hostname.includes('localhost')) {
       url = "http://localhost/vistosiwoocommerce/wp-admin/admin-ajax.php";
       } 
       return url;
      }
}